module.exports = __webpack_public_path__ + "media/common/images/badges/active/zkuseny_pruvodce-7a7661af2d89471caa8ad8e4b0055da4.svg";